import { useForm } from "@inertiajs/react"
import ProjectForm from "./ProjectForm"

interface AddProjectProps {
  onSuccess?: () => void
}

const AddProject = ({ onSuccess }: AddProjectProps) => {
  const { data, setData, post, processing, errors, reset } = useForm({
    title: "",
    description: "",
    tech_stack: "",
    github_url: "",
    demo_url: "",
    image_url: "",
    featured: false,
    image: null as File | null
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post("/admin/projects", {
      forceFormData: true,
      onSuccess: () => {
        reset()
        onSuccess?.()
      }
    })
  }

  return (
    <ProjectForm
      data={data}
      setData={setData}
      onSubmit={handleSubmit}
      submitLabel="Add Project"
      processing={processing}
      errors={errors}
    />
  )
}

export default AddProject